import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import { vMaska } from "maska"

import VueFeather from 'vue-feather';

import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';

import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import '@/assets/scss/config/modern/app.scss';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'

import { createPinia } from 'pinia';
import { setupAxiosInterceptors } from '@/helpers/axios-interceptor';

setupAxiosInterceptors();


// FakeBackend authentication
// import { configureFakeBackend } from './helpers/';
// configureFakeBackend();


// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);



AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
    window.__getFcmToken = async () => {
        const mod = await import('./helpers/firebase-messaging');
        const cfg = mod.getFirebaseMessagingDebugConfig();
        console.log('[FCM DEBUG] resolved config:', cfg);
        const result = await mod.setupFirebaseMessaging();
        console.log('[FCM DEBUG] setup result:', result);
        return result;
    };
}

const pinia = createPinia()

createApp(App)
    .use(store)
    .use(router)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .component('EasyDataTable', Vue3EasyDataTable)
    .component('VueDatePicker', VueDatePicker)
    .directive("maska", vMaska)
    .use(i18n)
    .use(VueSweetalert2)
    .use(pinia)
    .use(vClickOutside)
    .mount('#app');